export default "__VITE_ASSET__57e0fad5__"